// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { Mail, ArrowLeft, Loader2 } from 'lucide-react';
// import 'react-toastify/dist/ReactToastify.css';
// import SummaryApi from '../common/SummaryApi';
// // import Logo1 from '../assets/images/Logo1.png';

// const ForgotPassword = () => {
//   const [email, setEmail] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!email) {
//       const msg = 'Email is required';
//       setError(msg);
//       toast.error(msg);
//       return;
//     }

//     setLoading(true);

//     try {
//       await axios.post(SummaryApi.forgotPassword.url, { email });
//       setSuccess(true);
//       toast.success('Password reset link sent to your email');
//     } catch (err) {
//       const message = err.response?.data?.message || 'Error sending reset link';
//       setError(message);
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-blue-50 via-green-50 to-yellow-50">
//       {/* Modern Pattern Background */}
//       <div className="absolute inset-0 opacity-10">
//         <div
//           className="absolute inset-0"
//           style={{
//             backgroundImage: `
//               repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(59, 130, 246, 0.1) 35px, rgba(59, 130, 246, 0.1) 70px),
//               repeating-linear-gradient(-45deg, transparent, transparent 35px, rgba(239, 68, 68, 0.1) 35px, rgba(239, 68, 68, 0.1) 70px),
//               repeating-linear-gradient(90deg, transparent, transparent 50px, rgba(34, 197, 94, 0.1) 50px, rgba(34, 197, 94, 0.1) 100px)
//             `,
//           }}
//         />
//         {/* Floating Squares Pattern */}
//         <div className="absolute top-20 left-20 w-24 h-24 bg-blue-500 opacity-10 rounded-lg transform rotate-45" />
//         <div className="absolute top-40 right-40 w-32 h-32 bg-red-500 opacity-10 rounded-lg transform rotate-12" />
//         <div className="absolute bottom-20 left-1/3 w-28 h-28 bg-green-500 opacity-10 rounded-lg transform -rotate-12" />
//         <div className="absolute bottom-40 right-20 w-20 h-20 bg-yellow-500 opacity-10 rounded-lg transform rotate-45" />
//       </div>

//       {/* Centered Card */}
//       <div className="relative flex items-center justify-center min-h-screen p-4">
//         <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 backdrop-blur-sm">
//           {/* Logo and Header */}
//           <div className="text-center mb-8">
//             {/* <div className="flex justify-center mb-4">
//               <div className="w-12 h-12">
//                 <img
//                   src={Logo1}
//                   alt="Cuso Business Logo"
//                   className="w-12 h-12 object-contain"
//                 />
//               </div>
//             </div> */}
//             <h1 className="text-3xl font-bold text-gray-900 mb-2">
//               Forgot your password?
//             </h1>
//             <p className="text-gray-600">
//               {success
//                 ? 'We’ve sent a password reset link to your email address.'
//                 : 'Enter the email associated with your account and we’ll send you a reset link.'}
//             </p>
//           </div>

//           {/* Form / Actions */}
//           {!success ? (
//             <form onSubmit={handleSubmit} className="space-y-6">
//               {/* Email Field */}
//               <div>
//                 <label
//                   htmlFor="email"
//                   className="block text-sm font-medium text-gray-700 mb-2"
//                 >
//                   Email address
//                 </label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <Mail className="h-5 w-5 text-gray-400" />
//                   </div>
//                   <input
//                     type="email"
//                     id="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     placeholder="m@example.com"
//                     className={`
//                       w-full pl-10 pr-3 py-3 bg-white border rounded-lg text-gray-900 placeholder-gray-400
//                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//                       transition-all duration-200
//                       ${error ? 'border-red-300' : 'border-gray-300'}
//                     `}
//                     disabled={loading}
//                     autoComplete="email"
//                   />
//                 </div>
//                 {error && (
//                   <p className="mt-1 text-sm text-red-600">{error}</p>
//                 )}
//               </div>

//               {/* Submit Button */}
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg font-medium 
//                            hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
//                            disabled:opacity-50 disabled:cursor-not-allowed
//                            transition-all duration-200 flex items-center justify-center shadow-lg"
//               >
//                 {loading ? (
//                   <>
//                     <Loader2 className="animate-spin -ml-1 mr-2 h-5 w-5" />
//                     Sending reset link...
//                   </>
//                 ) : (
//                   'Send reset link'
//                 )}
//               </button>

//               {/* Back to Login link */}
//               <button
//                 type="button"
//                 onClick={() => navigate('/login')}
//                 className="mt-4 w-full inline-flex items-center justify-center text-sm text-gray-600 hover:text-blue-600 transition-colors"
//               >
//                 <ArrowLeft className="h-4 w-4 mr-2" />
//                 Back to login
//               </button>
//             </form>
//           ) : (
//             <div className="space-y-6">
//               <button
//                 onClick={() => navigate('/login')}
//                 className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg font-medium 
//                            hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
//                            transition-all duration-200 flex items-center justify-center shadow-lg"
//               >
//                 Back to login
//               </button>
//               <p className="text-xs text-gray-500 text-center">
//                 Didn&apos;t receive the email? Check your spam folder or try again in a few minutes.
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;


// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { Mail, ArrowLeft, Loader2 } from 'lucide-react';
// import SummaryApi from '../common/SummaryApi';

// const ForgotPassword = () => {
//   const [email, setEmail] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (!email) {
//       const msg = 'Email is required';
//       setError(msg);
//       toast.error(msg);
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await axios.post(SummaryApi.forgotPassword.url, { email });
      
//       if (response.data.success) {
//         toast.success(response.data.message || 'OTP sent successfully');
        
//         // Navigate to Reset Password page with email in state
//         navigate('/reset-password', { state: { email } });
//       }
//     } catch (err) {
//       const message = err.response?.data?.message || 'Error sending reset link';
//       setError(message);
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-blue-50 via-green-50 to-yellow-50">
//       {/* Modern Pattern Background */}
//       <div className="absolute inset-0 opacity-10">
//         <div
//           className="absolute inset-0"
//           style={{
//             backgroundImage: `
//               repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(59, 130, 246, 0.1) 35px, rgba(59, 130, 246, 0.1) 70px),
//               repeating-linear-gradient(-45deg, transparent, transparent 35px, rgba(239, 68, 68, 0.1) 35px, rgba(239, 68, 68, 0.1) 70px),
//               repeating-linear-gradient(90deg, transparent, transparent 50px, rgba(34, 197, 94, 0.1) 50px, rgba(34, 197, 94, 0.1) 100px)
//             `,
//           }}
//         />
//         {/* Floating Squares Pattern */}
//         <div className="absolute top-20 left-20 w-24 h-24 bg-blue-500 opacity-10 rounded-lg transform rotate-45" />
//         <div className="absolute top-40 right-40 w-32 h-32 bg-red-500 opacity-10 rounded-lg transform rotate-12" />
//         <div className="absolute bottom-20 left-1/3 w-28 h-28 bg-green-500 opacity-10 rounded-lg transform -rotate-12" />
//         <div className="absolute bottom-40 right-20 w-20 h-20 bg-yellow-500 opacity-10 rounded-lg transform rotate-45" />
//       </div>

//       {/* Centered Card */}
//       <div className="relative flex items-center justify-center min-h-screen p-4">
//         <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 backdrop-blur-sm">
          
//           {/* Header */}
//           <div className="text-center mb-8">
//             <h1 className="text-3xl font-bold text-gray-900 mb-2">
//               Forgot your password?
//             </h1>
//             <p className="text-gray-600">
//               Enter the email associated with your account and we’ll send you an OTP.
//             </p>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit} className="space-y-6">
//             {/* Email Field */}
//             <div>
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-gray-700 mb-2"
//               >
//                 Email address
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <Mail className="h-5 w-5 text-gray-400" />
//                 </div>
//                 <input
//                   type="email"
//                   id="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="m@example.com"
//                   className={`
//                     w-full pl-10 pr-3 py-3 bg-white border rounded-lg text-gray-900 placeholder-gray-400
//                     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
//                     transition-all duration-200
//                     ${error ? 'border-red-300' : 'border-gray-300'}
//                   `}
//                   disabled={loading}
//                   autoComplete="email"
//                 />
//               </div>
//               {error && (
//                 <p className="mt-1 text-sm text-red-600">{error}</p>
//               )}
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg font-medium 
//                          hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
//                          disabled:opacity-50 disabled:cursor-not-allowed
//                          transition-all duration-200 flex items-center justify-center shadow-lg"
//             >
//               {loading ? (
//                 <>
//                   <Loader2 className="animate-spin -ml-1 mr-2 h-5 w-5" />
//                   Sending...
//                 </>
//               ) : (
//                 'Send OTP'
//               )}
//             </button>

//             {/* Back to Login link */}
//             <button
//               type="button"
//               onClick={() => navigate('/login')}
//               className="mt-4 w-full inline-flex items-center justify-center text-sm text-gray-600 hover:text-blue-600 transition-colors"
//             >
//               <ArrowLeft className="h-4 w-4 mr-2" />
//               Back to login
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from "react-hot-toast";
import { Loader2 } from 'lucide-react';
import SummaryApi from '../common/SummaryApi';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // --- SHARED CLASSES (Matches SignUp.js) ---
  const inputClasses = "block px-4 py-3 w-full text-sm text-gray-900 bg-blue-50 rounded-md border-2 border-blue-200 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer placeholder-transparent";
  const labelClasses = "absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-3 bg-white px-2 text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:top-1/2 peer-placeholder-shown:bg-transparent peer-placeholder-shown:text-gray-500 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:bg-white peer-focus:px-2 peer-focus:text-blue-600";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Email is required');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(SummaryApi.forgotPassword.url, { email });
      
      if (response.data.success) {
        toast.success(response.data.message || 'OTP sent successfully');
        // Navigate to Reset Password page with email in state
        navigate('/reset-password', { state: { email } });
      }
    } catch (err) {
      const message = err.response?.data?.message || 'Error sending reset link';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#bfdaf9] font-sans text-gray-800 flex flex-col">
      <main className="flex-1 flex items-center justify-center p-4">
        {/* Card Container matches SignUp.js */}
        <div className="bg-white w-full max-w-[500px] rounded-sm shadow-xl p-8 md:px-12 md:py-10 text-center relative animate-fade-in">
          
          {/* Header */}
          <h2 className="text-2xl font-bold mb-2 text-black">
            Forgot Password?
          </h2>
          <p className="text-xs text-gray-800 font-medium mb-8">
            Enter the email associated with your account and we’ll send you an OTP.
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            
            {/* Email Input (Floating Label Pattern) */}
            <div className="relative mb-6 text-left">
              <div className="relative">
                <input
                  type="email"
                  id="email"
                  className={inputClasses}
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
                <label htmlFor="email" className={labelClasses}>
                  Email Address
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center mb-6 transition-colors flex items-center justify-center"
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin -ml-1 mr-2 h-4 w-4" />
                  Sending OTP...
                </>
              ) : (
                'Send OTP'
              )}
            </button>
          </form>

          {/* Back to Login Link */}
          <div className="text-sm text-gray-500">
            Remember your password?{' '}
            <button
              onClick={() => navigate('/login')}
              className="text-blue-600 font-semibold underline inline-flex items-center"
            >
               Sign in
            </button>
          </div>

        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;